import { render } from "./grid.vue?vue&type=template&id=36a40c3d&scoped=true"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"

import "./grid.vue?vue&type=style&index=0&id=36a40c3d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a40c3d"]])

export default __exports__